import styled from 'styled-components'

export const Button = styled.button`
    padding: 5px 30px;
    font-size: 1.2rem;
    font-weight: 400;
    border-radius: 5px;
    color: ${(props) => {return props.theme.colorSecoundary}};
    background: ${(props) => {return props.theme.colorPrimary}};
    cursor: pointer;
    user-select: none;
`
